import { escapeEmailTemplateHtml } from './campaignEmailTemplate';
import { buildEmailAnchorInlineStyle } from './emailButtonStyles';

/**
 * Bloc HTML email (tables) — fiche produit.
 */
export function buildProductCardEmailHtml(product, options = {}) {
  const name = String(product?.name || 'Produit').trim();
  const descriptionHtml = String(product?.description || '').trim();
  const price =
    typeof product?.price === 'number' && !Number.isNaN(product.price)
      ? product.price
      : null;
  const imageUrl = String(product?.imageUrl || '').trim();
  const paymentUrl = String(options.paymentUrl || product?.paymentUrl || '').trim();

  const showImage = options.showImage !== false;
  const showDescription = options.showDescription !== false;

  const paymentLabel = String(
    options.paymentButtonLabel || options.paymentLabel || 'Payer ma commande',
  ).trim();

  const priceBlock =
    price != null && price > 0
      ? `<span style="display:inline-block;margin-top:8px;padding:6px 12px;border-radius:999px;background:#ecfdf5;color:#047857;font-weight:700;font-size:14px;">${escapeEmailTemplateHtml(
          price.toFixed(2),
        )} €</span>`
      : '';

  const imageBlock =
    showImage && imageUrl
      ? `<img src="${escapeEmailTemplateHtml(imageUrl)}" alt="" width="560" style="display:block;width:100%;max-width:560px;height:auto;border:0;object-fit:cover;" />`
      : showImage
        ? `<div style="height:160px;background:#f3f4f6;display:flex;align-items:center;justify-content:center;color:#9ca3af;font-size:13px;">Photo du produit</div>`
        : '';

  const descBlock =
    showDescription && descriptionHtml
      ? `<div style="margin-top:12px;font-size:14px;line-height:1.45;color:#6b7280;">${descriptionHtml}</div>`
      : '';

  const payStyle = buildEmailAnchorInlineStyle({
    backgroundColor:
      options.paymentButtonBackgroundColor || options.paymentButtonBg,
    borderColor: options.paymentButtonBorderColor,
    textColor: options.paymentButtonTextColor,
    shape: options.paymentButtonShape,
  });

  const payBlock = paymentUrl
    ? `<table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="margin-top:16px;">
  <tr><td align="center">
    <a href="${escapeEmailTemplateHtml(paymentUrl)}" target="_blank" rel="noopener" style="${payStyle}">${escapeEmailTemplateHtml(paymentLabel)}</a>
  </td></tr></table>`
    : '';

  const imageRow = imageBlock
    ? `<tr><td style="padding:0;line-height:0;">${imageBlock}</td></tr>`
    : '';

  return `
<table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="margin:16px 0;">
  <tr>
    <td>
      <table role="presentation" cellpadding="0" cellspacing="0" border="0" width="100%" style="border:1px solid #e5e7eb;border-radius:12px;overflow:hidden;background:#ffffff;">
        ${imageRow}
        <tr><td style="padding:16px 18px;">
          <p style="margin:0;font-size:18px;font-weight:700;color:#111827;line-height:1.3;">${escapeEmailTemplateHtml(name)}</p>
          ${priceBlock}
          ${descBlock}
          ${payBlock}
        </td></tr>
      </table>
    </td>
  </tr>
</table>`.trim();
}

export function productCardBuildOptionsFromEmailSource(source) {
  if (!source) return {};
  return {
    showImage:
      source.emailProductCardShowImage !== undefined
        ? Boolean(source.emailProductCardShowImage)
        : true,
    showDescription:
      source.emailProductCardShowDescription !== undefined
        ? Boolean(source.emailProductCardShowDescription)
        : true,
    paymentButtonLabel:
      String(source.emailProductCardPaymentButtonLabel || '').trim() ||
      'Payer ma commande',
    paymentButtonBackgroundColor:
      source.emailProductCardPaymentButtonBackgroundColor || '#111827',
    paymentButtonBorderColor:
      source.emailProductCardPaymentButtonBorderColor || '#111827',
    paymentButtonTextColor:
      source.emailProductCardPaymentButtonTextColor || '#ffffff',
    paymentButtonShape: source.emailProductCardPaymentButtonShape || 'rounded',
  };
}
